
import { GlobalResponseObject } from '@gtpl/shared-models/canteen-management';
import axios from 'axios';
import { connection } from '../../freebies-management';

export class CompanyServices {
      URL = connection.DEPLOY_URL + '/company';

    async createCompany(request: any): Promise<GlobalResponseObject> {
        return await axios.post(this.URL + '/createCompany', request)
            .then(res => {
                return res.data
            })
    }
}